import { gql } from '@apollo/client'

export default gql(`
    mutation($contents: [UpdatePublishRuleInput],  $parentAssetId: ID $project: String) {
        batchUpdatePublishRule(
          input: $contents, 
          parentAssetId: $parentAssetId
          project: $project
        ) {
            id
            assetId
            group{
              id
            }
            isEnabled
            publishEndDate
            publishStartDate
          }
    }`
)
